import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import { adminKeys } from './keys';
import type { AdminUsersResponse, PerspectivesResponse } from './types';

export const adminQueries = {
  users: () =>
    queryOptions({
      queryKey: adminKeys.users(),
      queryFn: (): Promise<AdminUsersResponse> => apiFetch('/admin/users'),
    }),

  perspectives: () =>
    queryOptions({
      queryKey: adminKeys.perspectives(),
      queryFn: (): Promise<PerspectivesResponse> => apiFetch('/perspectives?limit=100'),
    }),
};

export function useAdminUsers() {
  return useQuery(adminQueries.users());
}

export function useAdminPerspectives() {
  return useQuery(adminQueries.perspectives());
}
